// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'

// svg
import { ArrowRight } from '/react4xp/components/Icons/Ux'

// types
interface ListLinksProps {
    className?: string
    isAnimated?: boolean
    color?: 'green-light' | 'beige'
    title?: string
    intro?: string
    links?: {
        label?: string
        href?: string
        external?: boolean
    }[]
}

// css
import './index.scss'

export default function ListLinks({
    className,
    isAnimated,
    color,
    title,
    intro,
    links
}: ListLinksProps) {
    return (
        <Section className={clsx(
            'list-links-component',
            className
        )}>
            <div
                className='container'
                data-stagger-up={isAnimated ? 'true' : 'false'}
            >
                <RoundedBox bgColor={color}>
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1'>
                            <div className='list-links-component__wrapper'>

                                {title && (
                                    <h2 className='h2'>
                                        {title}
                                    </h2>
                                )}

                                {intro && (
                                    <div
                                        className='lead-paragraph list-links-component__intro'
                                        dangerouslySetInnerHTML={{
                                            __html: intro
                                        }}
                                    />
                                )}

                                {links && (
                                    <div className='list-links-component__links'>
                                        {links?.map((item, i) => (
                                            <a
                                                className='list-links-component__link'
                                                href={item.href}
                                                target={item.external ? '_blank' : undefined}
                                                rel={item.external ? 'noopener noreferrer' : undefined}
                                                key={i}
                                            >
                                                <span className='list-links-component__link-inner'>

                                                    <ArrowRight />

                                                    {item.label && (
                                                        <span className='body'>
                                                            {item.label}
                                                        </span>
                                                    )}

                                                </span>
                                            </a>
                                        ))}
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>

                </RoundedBox>
            </div>
        </Section>
    )
}